module.exports = __webpack_public_path__ + "img/right-1.15bf417e.png";